import React from "react";
import { TweenLite, Power4 } from "gsap";
import "./smooth-scroll.css";
export default class SmoothScroll extends React.Component {
  state = {
    height: window.innerHeight,
  };

  ro = new ResizeObserver((elements) => {
    for (let elem of elements) {
      const crx = elem.contentRect;
      // console.log(crx);
      this.setState({
        height: crx.height,
      });
    }
  });

  componentDidMount() {
    window.addEventListener("scroll", this.onScroll);
    this.ro.observe(this.viewport);
  }

  onScroll = () => {
    TweenLite.to(this.viewport, 1, {
      y: -window.pageYOffset,
      ease: Power4.easeOut,
    });
  };

  render() {
    return (
      <>
        <div className="viewport" ref={(ref) => (this.viewport = ref)}>
          {this.props.children}
        </div>
        <div
          ref={(ref) => (this.fake = ref)}
          style={{
            height: this.state.height,
          }}
        />
      </>
    );
  }
}

// import React, { useEffect, useRef } from "react";

// import "./smooth-scroll.css";
// import useWindowSize from "./useWindowSize";

// const SmoothScroll = ({ children }) => {
//   // 1.
//   const windowSize = useWindowSize();

//   //2.
//   const scrollingContainerRef = useRef();

//   // 3.
//   const data = {
//     ease: 0.1,
//     current: 0,
//     previous: 0,
//     rounded: 0,
//   };

//   // 4.
//   useEffect(() => {
//     setBodyHeight();
//   }, [windowSize.height]);

//   const setBodyHeight = () => {
//     document.body.style.height = `${
//       scrollingContainerRef.current.getBoundingClientRect().height
//     }px`;
//   };

//   // 5.
//   useEffect(() => {
//     requestAnimationFrame(() => smoothScrollingHandler());
//   }, []);

//   const smoothScrollingHandler = () => {
//     data.current = window.scrollY;
//     data.previous += (data.current - data.previous) * data.ease;
//     data.rounded = Math.round(data.previous * 100) / 100;

//     scrollingContainerRef.current.style.transform = `translateY(-${data.previous}px)`;

//     // Recursive call
//     requestAnimationFrame(() => smoothScrollingHandler());
//   };

//   return (
//     <div className="parent">
//       <div ref={scrollingContainerRef}>{children}</div>
//     </div>
//   );
// };

// export default SmoothScroll;
